import { createAsyncThunk } from "@reduxjs/toolkit";
import ThunkExtraArguments from "../../types/ThunkExtraArguements";
import { RootState } from "../store";
import {
  ElementLibraryModalProps,
  SelectLibraryElementProps,
  elementLibraryModalActions,
} from "store/elementLibrarySlice";

const elementLibraryModalThunkActions = {
  openElementLibraryThunk: createAsyncThunk<
    number,
    ElementLibraryModalProps,
    {
      extra: ThunkExtraArguments;
    }
  >(
    "elementLibraryModal",
    async (props: ElementLibraryModalProps, { extra, dispatch }) => {
      const store = extra.store;

      dispatch(elementLibraryModalActions.openElementLibraryModal(props));

      return new Promise<number>((resolve) => {
        const unsubscribe = store.subscribe(() => {
          const state: RootState = store.getState();
          if (state.elementLibraryModal.isSelected) {
            unsubscribe();
            resolve(state.elementLibraryModal.selectedElementId ?? 0);
          }
          if (state.elementLibraryModal.isDeclined) {
            unsubscribe();
            resolve(0);
          }
        });
      });
    }
  ),
  selectLibraryElementThunk: createAsyncThunk<
    number,
    SelectLibraryElementProps,
    {
      extra: ThunkExtraArguments;
    }
  >(
    "elementLibraryModal",
    async (props: SelectLibraryElementProps, { extra, dispatch }) => {
      const store = extra.store;

      dispatch(elementLibraryModalActions.selectLibraryElement(props));

      return new Promise<number>((resolve) => {
        const unsubscribe = store.subscribe(() => {
          const state: RootState = store.getState();
          if (state.elementLibraryModal.isSelected) {
            unsubscribe();
            resolve(state.elementLibraryModal.selectedElementId ?? 0);
          }
          if (state.elementLibraryModal.isDeclined) {
            unsubscribe();
            resolve(0);
          }
        });
      });
    }
  ),
};

export default elementLibraryModalThunkActions;
